var regularVariants = {
    40864104677411: "Calming",
    40864105332771: "Pain Relief",
    40864104546339: "Skin & Coat",
    40864105136163: "Probiotic",
    40864104874019: "Hip & Joint",
    43119155380398: "Eye Support",
    40864104906787: "Multivitamin",
    44403171033262: "Anal Glands",
    40864105103395: "Allergy & Immune",
    44053690712238: "5-in-1 Dog Wash",
    40864105070627: "Probiotic (Turkey & Bacon)",
    40864105365539: "Skin & Coat (Turkey & Bacon)",
    45054690164910: "Dental Wash",
    45054822809774: "Urinary & Bladder",
    46009740165294: "Bone Broth",
    46009740820654: "Pumpkin",
    46354029740206: "Allergy & Immune FB",
  },
  getFlavoredVersion = {
    40864105136163: 40864105070627,
    40864104546339: 40864105365539,
    40864104579107: 40864104742947,
    40864104382499: 40864105398307,
  },
  discountedVariants = {
    40864104644643: "Calming",
    40864104972323: "Pain Relief",
    40864104382499: "Skin & Coat",
    40864104579107: "Probiotic",
    40864104415267: "Hip & Joint",
    43119330295982: "Eye Support",
    40864105201699: "Multivitamin",
    43533318815918: "Anal Glands",
    40864104841251: "Allergy & Immune",
    44053697724590: "5-in-1 Dog Wash",
    40864104742947: "Probiotic (Turkey & Bacon)",
    40864105398307: "Skin & Coat (Turkey & Bacon)",
    45054706516142: "Dental Wash",
    45054831591598: "Urinary & Bladder",
    46009740230830: "Bone Broth",
    46009743311022: "Pumpkin",
  },
  getUpsellBodyText = {
    40864104382499: "A powerful duo to protect from itching, allergies and paw biting. Get them at 50% off!",
    40864104579107: "Protect your dog inside and out by boosting their gut health. Get them at 50% off!",
    40864104972323: "The natural way to calming and relieving your pup of pain and stress,",
    40864104644643: "These delicious chews help with  anxiety, stress, travels and more! Get them at 50% off.",
    40864104415267: "Get to the root of the pain by supporting your dog's hips and joints. Get them for 50% off!",
    43119330295982: "Get  lasting results and keep your dog's vision in top shape with an extra jar at 50% off!",
    40864105201699: "Complete their diet with robust nutrition thanks to these 15-in 1 chews.",
    43533318815918: "Get rid of scooting, digestive issues and odors with these delicious chews at 50% off!",
    40864104841251: "Get another jar for more effective, longer lasting protection from allergies at 50% off!",
    44053697724590: "Save an extra £5 when you add an additional bottle. ",
    40864104742947: "Protect your dog inside and out by boosting their gut health. Get them at 50% off!",
    40864105398307: "A powerful duo to protect from itching, allergies and paw biting. Get them at 50% off!",
    45054706516142: "Save and get lasting results with an extra bottle at a special discount.",
    45054831591598: "Save and get longer lasting results with this special offer on an extra jar of our UTI Chews.",
    46009740230830: "Add this delicious topper to make sure they're covered from the inside and out.",
    46009743311022: "Add this delicious topper to make sure they're covered from the inside and out.",
  },
  getUpsellImage = {
    40864104644643: "https://cdn.shopify.com/s/files/1/0506/0424/5166/t/1/assets/calming.png",
    40864104972323: "https://cdn.shopify.com/s/files/1/0506/0424/5166/t/1/assets/pairelief.png",
    40864104382499: "https://cdn.shopify.com/s/files/1/0506/0424/5166/t/1/assets/skincoat.png",
    40864104579107: "https://cdn.shopify.com/s/files/1/0506/0424/5166/t/1/assets/probiotic.png",
    40864104415267: "https://cdn.shopify.com/s/files/1/0506/0424/5166/t/1/assets/hipjoint.png?v=12",
    43119330295982: "https://cdn.shopify.com/s/files/1/0506/0424/5166/files/eyesupport-cover.png?v=1658313904",
    40864105201699: "https://cdn.shopify.com/s/files/1/0506/0424/5166/files/multivitamin-cover.png?v=1658313905",
    43533318815918: "https://cdn.shopify.com/s/files/1/0506/0424/5166/files/analglands_x190.png?v=1667978221",
    40864104841251: "https://cdn.shopify.com/s/files/1/0506/0424/5166/files/shop-allergy_x190.png?v=1680189123",
    44053697724590: "https://cdn.shopify.com/s/files/1/0506/0424/5166/files/shop-shampoo1_x200.png?v=1690351334",
    40864104742947: "https://cdn.shopify.com/s/files/1/0506/0424/5166/t/1/assets/probiotic.png",
    40864105398307: "https://cdn.shopify.com/s/files/1/0506/0424/5166/t/1/assets/skincoat.png",
    45054706516142: "https://cdn.shopify.com/s/files/1/0506/0424/5166/files/dental-wash-cover-2.png?v=1715170609",
    45054831591598: "https://pawfy.co.uk/cdn/shop/files/urinary-cover_e64e9f6c-fc32-4c34-a009-51cedcc89dd1_400x620.png?v=1713432130",
    46009740230830: "https://pawfy.co.uk/cdn/shop/files/bone-broth-cover_400x620.png?v=1733321237",
    46009743311022: "https://pawfy.co.uk/cdn/shop/files/pumpkin-cover_400x620.png?v=1733321336",
  },
  getUpsell = {
    40864104677411: 40864104579107, // Calming upsell is Probiotic
    40864105332771: 40864104415267, // Pain Relief upsell is Hip & Joint
    40864104546339: 40864104579107, // Skin & Coat upsell is Probiotic
    40864105136163: 40864104382499, // Probiotic upsell is Skin & Coat
    40864105070627: 40864105398307, // Probiotic (TB) upsell is Skin & Coat (TB)
    40864104874019: 40864104972323, // Hip & Joint upsell is Pain Relief
    43119155380398: 40864105201699, // Eye Support upsell is Multivitamin
    40864104906787: 40864104579107, // Multivitamin upsell is Probiotic
    44403171033262: 40864104579107, // AG is Probiotic
    40864105103395: 40864104382499, // Allergy is Skin & Coat
    44053690712238: 40864104382499, // Shampoo - Skin Coat
    40864105365539: 40864104742947, // Skin & Coat (TB) - Probiotic (TB)
    45054690164910: 44053697724590, // "Dental Wash",
    45054822809774: 40864104579107, // "Urinary & Bladder"
    46009740165294: 46009743311022,
    46009740820654: 46009740230830,
    46354029740206: 40864104382499, // Allergy is Skin & Coat
  },
  getDiscountedVariant = {
    40864104677411: 40864104644643,
    40864105332771: 40864104972323,
    40864104546339: 40864104382499,
    40864105136163: 40864104579107,
    40864104874019: 40864104415267,
    43119155380398: 43119330295982,
    40864104906787: 40864105201699,
    44403171033262: 43533318815918,
    40864105103395: 40864104841251,
    44053690712238: 44053697724590,
    40864105070627: 40864104742947,
    40864105365539: 40864105398307,
    45054690164910: 45054706516142,
    45054822809774: 45054831591598,
    46009740165294: 46009740230830,
    46009740820654: 46009743311022,
    46354029740206: 40864104841251,
  },
  getSellingPlan = { 
    40864105136163: [ 4529192995, 4529225763, 4529258531 ] , // Probiotic
    40864104874019: [ 4529389603, 4529422371, 4529455139 ] , // Hip & Joint
    40864105332771: [ 4529487907, 4529520675, 4529553443 ] , // Pain Relief
    40864104677411: [ 4529094691, 4529127459, 4529160227 ] , // Calming
    40864105103395: [ 3784310819, 4528799779, 4528767011 ] , // Allergy & Immune
    40864104546339: [ 4528996387, 4529029155, 4529061923 ] , // Skin & Coat
    40864104579107: [ 4529881123, 4529913891, 4529946659 ] , // Probiotic Special
    40864104415267: [ 4529291299, 4529324067, 4529356835 ] , // Hip & Joint Special
    40864104972323: [ 4529684515, 4529717283, 4529750051 ] , // Pain Relief Special
    40864104644643: [ 4529586211, 4529618979, 4529651747 ] , // Calming Special
    40864104382499: [ 4529782819, 4529815587, 4529848355 ] , // Skin & Coat Special
    40864104841251: [ 4530176035, 4530208803, 4530241571 ] , // Allergy & Immune Special
    40864104906787: [ 4529979427, 4530012195, 4530044963 ] , // Multivitamin
    40864105201699: [ 4530077731, 4530143267, 4530110499 ] , // Multivitamin Special  
};

var Pawfy = {
  openOTPModal: function () {
    fetch(`${window.location.pathname}?section_id=otp-modal`)
      .then((res) => res.text())
      .then((html) => {
        // Parse and extract just the modal section content
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const modalContent = doc.querySelector("#shopify-section-otp-modal");

        if (modalContent) {
          document.querySelector("#modal-container").innerHTML = modalContent.innerHTML;
          // Show the modal
          document.querySelector("#modal-container").classList.add("open");

          document.querySelector("body").style.overflow = "hidden";

          document.querySelector("#yes-sub").addEventListener("click", function (ev) {
            ev.preventDefault();
            console.log("clicked 2");
            // document.querySelector(`[value="sub"]`).click()
            document.querySelector("body").style.overflow = "";
            document.querySelector("#modal-container").innerHTML = "";
            document.querySelector("#modal-container").classList.remove("open");
          });
          document.querySelector("#yes-otp").addEventListener("click", function (ev) {
            ev.preventDefault();
            document.querySelector(`.buy-once`).click();
            document.querySelector("body").style.overflow = "";
            document.querySelector("#modal-container").innerHTML = "";
            document.querySelector("#modal-container").classList.remove("open");
          });

          Pawfy.closeOTPModal();
        }
      })
      .catch((err) => console.error("Error loading modal:", err));
  },
  closeOTPModal: function () {
    document.querySelector("[data-modal-close]").addEventListener("click", function () {
      document.querySelector("body").style.overflow = "";
      document.querySelector("#modal-container").innerHTML = "";
      document.querySelector("#modal-container").classList.remove("open");
    });
  },
  handleClick: function (ev) {        
        ev.preventDefault();
        var primaryVariant = window.substituteVariant ? window.substituteVariant : meta.product.variants[0].id;
        var selectedUpsellVariant = ev.target.closest(".product-atf__right-purchasetype").querySelector(".upsell").dataset.variant;
        var primaryUpsellVariant = window.substituteVariant ? getFlavoredVersion[selectedUpsellVariant] : selectedUpsellVariant;
        var totalQuantity = Number(ev.target.closest(".product-atf__right-purchasetype").querySelector('[name="qty"]:checked').value);

        var xhr = new XMLHttpRequest();
        var items = [
          {
            quantity: totalQuantity,
            id: primaryVariant,
            selling_plan: ev.target.closest(".product-atf__right-purchasetype").classList.contains("product-atf__right-purchasetype-sub") ? getSellingPlan[Number(primaryVariant)][0] : null,
            properties: {
              /*Type: "PDP Purchase",*/
            },
          },
          {
            quantity: ev.target.closest(".product-atf__right-purchasetype").querySelector(".upsell__input input").checked ? 1 : 0,
            id: primaryUpsellVariant,
            selling_plan: ev.target.closest(".product-atf__right-purchasetype").classList.contains("product-atf__right-purchasetype-sub") ? getSellingPlan[primaryUpsellVariant][0] : null,
            properties: {
            "Bought With": meta.product.variants[0].name
            },
          },
        ];

        xhr.onreadystatechange = function () {
          if (xhr.readyState == 4 && xhr.status == 200) {
            document.querySelector("[data-cart-toggle]").click();
          }
        };

        xhr.open("POST", "/cart/add.js", true);
        xhr.setRequestHeader("Content-Type", "application/json");
        xhr.send(
          JSON.stringify({
            attributes: {
             /* Type: "PDP Purchase",*/
            },
            items: items,
          })
        );
      },

  initUpsell: function (quantity, parentVariantID) {
    var upsellName = "",
      upsellVariantID = 0,
      upsellHeading = document.querySelector(".product-atf__right-purchasetype--active .upsell__body b"),
      upsellWrapper = document.querySelector(".product-atf__right-purchasetype--active .upsell"),
      upsellBody = document.querySelector(".product-atf__right-purchasetype--active .upsell__body p"),
      upsellImg = document.querySelector(".product-atf__right-purchasetype--active .upsell__image img");
    if (document.body.classList.contains("template-product")) {
      parentVariantID = Number(meta.product.variants[0].id);
    }
    upsellWrapper.classList.remove("hip", "pain", "skin", "calming", "probiotic", "multivitamin", "eye", "5-in-1", "anal", "urinary", "mouth");

    if (parseInt(quantity) == 1) {
      upsellVariantID = getDiscountedVariant[parentVariantID];
      upsellName = String(regularVariants[parentVariantID]);
      upsellHeading.innerText = `Add Another ${parentVariantID == 44053690712238 || parentVariantID == 45054690164910 ? "Bottle" : "Jar"} For Just £19.99!`;
      upsellBody.innerText = getUpsellBodyText[upsellVariantID];
      upsellImg.src = getUpsellImage[upsellVariantID];
    } else {
      upsellVariantID = getUpsell[parentVariantID];
      upsellName = String(discountedVariants[upsellVariantID]);
      upsellHeading.innerText = `Add Our ${upsellName} ${parentVariantID == 44053690712238 || parentVariantID == 45054690164910 ? "" : ""} For Just £19.99!`;
      upsellBody.innerText = getUpsellBodyText[upsellVariantID];
      upsellImg.src = getUpsellImage[upsellVariantID];
    }

    upsellWrapper.classList.add(upsellName.split(" ")[0].toLocaleLowerCase());
    upsellWrapper.dataset.variant = upsellVariantID;
    
    document.querySelectorAll(".addToCart").forEach((button) => {
      button.removeEventListener("click", Pawfy.handleClick);
      button.addEventListener("click", Pawfy.handleClick);
    });
  },
  jarQuantites: {
    1: {
      1: 35,
      2: 65,
      3: 90,
    },
    2: {
      1: 65,
      2: 120,
      3: 150,
    },
    3: {
      1: 90,
      2: 150,
      3: 180,
    },
    4: {
      1: 120,
      2: 160,
      3: 225,
    },
  },
  randomInteger: function (min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  },
  initCarousels: function () {
    if (document.getElementById("homepage-product-slider")) {
      if (document.querySelectorAll("#homepage-product-slider .splide__slide").length > 3 || window.innerWidth <= 820)
        window.addEventListener("load", function () {
          new Splide("#homepage-product-slider", {
            type: "loop",
            perPage: 4,
            gap: window.innerWidth <= 820 ? 16 : 16,
            autoplay: false,
            padding: window.innerWidth <= 820 ? 0 : 16,
            interval: 6000,
            pagination: false,
            arrows: true,
            arrowPath: "M24.3023 1.44192L31.0003 8.13982M24.3023 14.8377L31.0003 8.13982M31.0003 8.13982L-4.27461e-05 8.14054",
            breakpoints: {
              820: {
                perPage: 1,
                grid: {
                  rows: 2,
                  cols: 2,
                  gap: {
                    row: "1rem",
                    col: "1rem",
                  },
                },
              },
            },
          }).mount(window.splide.Extensions);
        });
    }
    if (document.getElementById("related-product-slider")) {
      if (document.querySelectorAll("#related-product-slider .splide__slide").length > 3 || window.innerWidth <= 820)
        function shuffleElements(container) {
          var elements = container.children;
          for (var i = elements.length; i >= 0; i--) {
            container.appendChild(elements[(Math.random() * i) | 0]);
          }
        }

      window.addEventListener("load", function () {
        var container = document.getElementById("shuffle");
        if (!!container) {
          shuffleElements(container);
        }

        new Splide("#related-product-slider", {
          type: "loop",
          perPage: 4,
          gap: window.innerWidth <= 820 ? 16 : 16,
          autoplay: false,
          padding: window.innerWidth <= 820 ? 0 : 16,
          interval: 6000,
          pagination: false,
          arrows: true,
          arrowPath: "M24.3023 1.44192L31.0003 8.13982M24.3023 14.8377L31.0003 8.13982M31.0003 8.13982L-4.27461e-05 8.14054",
          breakpoints: {
            820: {
              perPage: 1,
              grid: {
                rows: 1,
                cols: 2,
                gap: {
                  row: "1rem",
                  col: "1rem",
                },
              },
            },
          },
        }).mount(window.splide.Extensions);
      });
    }
    if (document.getElementById("product-slider")) {
      var productSplide = new Splide("#product-slider", {
        type: "loop",
        perPage: 1,
        gap: 0,
        autoplay: false,
        interval: 6000,
        pagination: false,
        dots: false,
        padding: 0,
        arrowPath:
          "M5.64612 2.31246C5.45086 2.50772 5.45086 2.82431 5.64612 3.01957L10.6259 7.99936L5.64612 12.9791C5.45086 13.1744 5.45086 13.491 5.64612 13.6862C5.84138 13.8815 6.15796 13.8815 6.35323 13.6862L11.6866 8.35291C11.7803 8.25915 11.833 8.13197 11.833 7.99936C11.833 7.86675 11.7803 7.73958 11.6866 7.64581L6.35323 2.31246C6.15797 2.1172 5.84138 2.1172 5.64612 2.31246Z",
        arrows: true,
      }).mount();

      var controls = document.querySelectorAll(".splide__controls li");

      controls.forEach((control) => {
        control.addEventListener("click", function (ev) {
          ev.preventDefault();
          controls.forEach((ctrl) => {
            ctrl.classList.remove("active");
          });
          productSplide.go(Number(this.dataset.id));
          control.classList.add("active");
        });
      });
    }
    if (window.innerWidth <= 160 && document.getElementById("inside")) {
      new Splide("#inside", {
        type: "loop",
        perPage: 1,
        gap: window.innerWidth <= 560 ? 0 : 48,
        autoplay: false,
        interval: 6000,
        pagination: false,
        padding: window.innerWidth <= 560 ? 0 : 48,
        arrows: true,
        arrowPath: "M24.3023 1.44192L31.0003 8.13982M24.3023 14.8377L31.0003 8.13982M31.0003 8.13982L-4.27461e-05 8.14054",
        breakpoints: {
          560: {
            perPage: 1,
          },
          820: {
            perPage: 2,
          },
        },
      }).mount();
    }
    if (document.getElementById("testimonials-1")) {
      var splide = new Splide("#testimonials-legal", {
        type: "loop",
        perPage: 3,
        gap: "2rem",
        autoplay: !0,
        interval: window.innerWidth <= 820 ? 6e3 : 3e4,
        autoHeight: !0,
        focus: "center",
        pagination: true,
        padding: "2rem",
        arrows: true,
        arrowPath: "M24.3023 1.44192L31.0003 8.13982M24.3023 14.8377L31.0003 8.13982M31.0003 8.13982L-4.27461e-05 8.14054",
        dots: true,
        breakpoints: {
          820: {
            perPage: 1,
            grid: {
              rows: 2,
              cols: 2,
              gap: {
                row: "2rem",
                col: "2rem",
              },
            },
          },
          560: {
            perPage: 1,
            padding: 0,
            grid: {
              rows: 3,
              cols: 1,
              gap: {
                row: "1rem",
                col: 0,
              },
            },
          },
        },
        arrowPath: "M24.3023 1.44192L31.0003 8.13982M24.3023 14.8377L31.0003 8.13982M31.0003 8.13982L-4.27461e-05 8.14054",
      }).mount(window.splide.Extensions);
      setTimeout(function () {
        splide.go(">"),
          setTimeout(function () {
            splide.go("<");
          }, 500);
      }, 400);
    }

    if (document.getElementById("two-packs")) {
      if (window.innerWidth <= 1024) {
        new Splide("#two-packs", {
          type: "loop",
          perPage: 1,
          gap: "1rem",
          autoplay: false,
          interval: 6000,
          autoHeight: true,
          pagination: false,
          padding: "1rem",
          arrows: true,
          arrowPath: "M24.3023 1.44192L31.0003 8.13982M24.3023 14.8377L31.0003 8.13982M31.0003 8.13982L-4.27461e-05 8.14054",
          breakpoints: {
            1024: {
              perPage: 1,
              grid: {
                rows: 2,
                cols: 2,
                gap: {
                  row: "1rem",
                  col: "1rem",
                },
              },
            },
          },
        }).mount(window.splide.Extensions);
      }
    }
    if (document.getElementById("testimonials-new")) {
      if (window.innerWidth >= 820) {
        document.querySelectorAll("#testimonials-new li.mobile-show").forEach((button) => {
          button.remove();
        });
      } else {
        document.querySelectorAll("#testimonials-new li:not(.mobile-show)").forEach((button) => {
          button.remove();
        });
      }
      var splide = new Splide("#testimonials-new", {
        type: "loop",
        perPage: 1,
        gap: window.innerWidth <= 820 ? 16 : 48,
        autoplay: true,
        interval: window.innerWidth <= 820 ? 6000 : 30000,
        autoHeight: true,
        focus: "center",
        pagination: false,
        padding: window.innerWidth <= 820 ? 48 : 24,
        arrows: true,
        arrowPath: "M 24.3023 1.44192 L 31.0003 8.13982 M 24.3023 14.8377 L 31.0003 8.13982 M 31.0003 8.13982 L -0.0000427461 8.14054",
      }).mount();
      setTimeout(function () {
        splide.go(">");
        setTimeout(function () {
          splide.go("<");
        }, 500);
      }, 400);
    }
  },
  customSticky: function () {
    if (window.scrollY >= 10) {
      document.querySelector("header.header").classList.add("header--sticky");
    } else {
      document.querySelector("header.header").classList.remove("header--sticky");
    }
  },
  initResponsiveMenu: function () {
    document.querySelector(".menu-toggle").addEventListener("click", function (ev) {
      ev.preventDefault();
      document.querySelector("header.header").classList.toggle("active");
      document.querySelector("header.header ul").classList.toggle("active");
    });
  },
  createElementFromHTML: function (htmlString) {
    var div = document.createElement("div");
    div.innerHTML = htmlString.trim();

    // Change this to div.childNodes to support multiple top-level nodes
    return div.firstChild;
  },
  initFAQ: function () {
    var questions = document.querySelectorAll(".faq__list-question");
    for (var j = 0; j < questions.length; j++) {
      questions[j].addEventListener("click", function (ev) {
        ev.preventDefault();
        ev.stopImmediatePropagation();
        ev.stopPropagation();
        var that = this;
        if (that.classList.contains("active")) {
          that.nextElementSibling.classList.remove("active");
          that.classList.remove("active");
        } else {
          var answers = document.querySelectorAll(".faq__list-answer");

          for (var i = 0; i < answers.length; i++) {
            answers[i].classList.remove("active");
          }

          for (var j = 0; j < questions.length; j++) {
            questions[j].classList.remove("active");
          }

          that.classList.add("active");
          that.nextElementSibling.classList.add("active");
        }
      });
    }
  },
  insertAfter: function (newNode, existingNode) {
    existingNode.parentNode.insertBefore(newNode, existingNode.nextSibling);
  },
  insertBefore: function (newNode, existingNode) {
    existingNode.parentNode.insertBefore(newNode, existingNode);
  },
  toggleTabs: function () {
    var tabs = document.querySelectorAll(".pawfy-tab__header-item"),
      contents = document.querySelectorAll(".pawfy-tab__content-item");
    for (var j = 0; j < tabs.length; j++) {
      tabs[j].addEventListener("click", function () {
        for (var c = 0; c < contents.length; c++) {
          contents[c].classList.remove("active");
          tabs[c].classList.remove("active");
        }
        this.classList.add("active");
        document.querySelector(".pawfy-tab__content-item[data-id='" + this.dataset.id + "']").classList.add("active");
      });
    }
  },

  rewordReCharge: function () {
    var root = document.querySelector("section.rc-login");
    var customer =
      Pawfy.getCookie("subscription_customer").length > 5 ? JSON.parse(Pawfy.getCookie("subscription_customer")) : JSON.parse(JSON.stringify({ isSub: false, email: "" }));
    var isSub = customer.isSub,
      customerEmail = customer.email;
    document.body.classList.add("recharge-login");
    var sectionTitle = document.querySelector("section.rc-login").querySelector("h1.rc-login--header-title");
    var sectionBody = document.querySelector("section.rc-login").querySelector("label.rc-login-form-label");
    if (sectionBody) {
      if (isSub && !!document.getElementById("rc-email")) {
        document.getElementById("rc-email").value = customerEmail;
        //document.getElementById("login_verification").submit();
        sectionTitle.innerText = "Access Subscription";
        document.querySelector("button.rc-login-form-button.animated span").innerText = "Send Login Link (Email & SMS)";

        sectionBody.innerText = "We have detected a subscription account with this e-mail. Click 'Submit' to get access to your account.";
      } else {
        document.querySelector("button.rc-login-form-button.animated span").innerText = "Send Login Link (Email & SMS)";
        sectionTitle.innerText = "Access Subscription";
        sectionBody.innerHTML = "Please enter <b>the email you used for your order</b> to access your subscription.";
        Pawfy.insertAfter(
          Pawfy.createElementFromHTML(`<div style="font-size: 12px;padding: 0 2rem;text-align: center;color: #123840;"><br><h4 style="
font-size: 18px;
margin: 0rem 0 16px 0;
">Need Help?</h4>You may access your subscription using this page to modify your delivery frequency or cancel your subscription. In order to gain access, please ensure you are using the same email you placed your initial order with.
<br>

<br>
<b>If you need help managing your subscription, please <a href="/pages/contact-us">Contact Us Here</a>. We're happy to help you manage your subscription as needed.</b></div>`),
          document.querySelector(".rc-login--body")
        );
        root.style.opacity = 1;
      }
    } else {
      if (isSub) {
        sectionBody.innerHTML = `
We have sent you an e-mail to: <b>${customerEmail}</b><br>
Please check your inbox (including spam) for a link to access your subscription.
`;
      }
      root.style.opacity = 1;
    }
  },

  setCookie: function (cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  },
  getCookie: function (cname) {
    let name = cname + "=";
    let ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  },
  initNotification: function () {
    var notificationEl = document.getElementById("pawfy-notification");
    if (!notificationEl) {
      return false;
    }
    if (notificationEl.innerText.trim().length > 10) {
      let notification = Pawfy.getCookie("notification");
      if (notification !== "true") {
        notificationEl.style.display = "block";
        notificationEl.classList.remove("inactive");
      }
      document.getElementById("close-notification").addEventListener("click", function () {
        Pawfy.setCookie("notification", "true", 10);
        notificationEl.classList.add("inactive");
      });
    }
  },
  initReviews: function () {
    document.getElementById("submit").addEventListener("click", function (ev) {
      if (!document.getElementById("newReview").checkValidity()) return false;
      document.querySelector(".confirmation img").src = document.querySelector(".confirmation img").src;
      document.querySelector(".confirmation").classList.add("show");
      setTimeout(function () {
        document.querySelector(".reviews-modal").classList.remove("visible");
        document.querySelector(".confirmation").classList.remove("show");
      }, 2000);
    });
    var rateStars = document.getElementsByName("rating"),
      allReviews = document.querySelectorAll("[data-rating]"),
      readmores = document.querySelectorAll(".read-more");

    for (var s = 0; s < rateStars.length; s++) {
      if (!rateStars[s]) return false;
      rateStars[s].addEventListener("click", function (ev) {
        var rating = this.value;
        var filtered = document.querySelectorAll("[data-rating='" + rating + "']");
        for (var a = 0; a < allReviews.length; a++) {
          var item = allReviews[a];
          item.classList.add("hide-animate");
        }
        setTimeout(function () {
          for (var a = 0; a < allReviews.length; a++) {
            var item = allReviews[a];
            item.classList.remove("show");
            item.classList.remove("show-animate");
            item.classList.add("hide");
          }
          for (var f = 0; f < filtered.length; f++) {
            var item = filtered[f];
            item.classList.add("show");
            item.classList.remove("hide");
            item.classList.remove("hide-animate");
          }

          setTimeout(function () {
            for (var f = 0; f < filtered.length; f++) {
              var item = filtered[f];
              item.classList.add("show-animate");
            }
          }, 300);
        }, 300);

        if (filtered.length == 0) {
          document.querySelector(".reviews-list__footer").classList.add("hide");
        } else {
          document.querySelector(".reviews-list__footer").classList.remove("hide");
        }
      });
    }

    for (var r = 0; r < readmores.length; r++) {
      if (!readmores[r]) return false;
      readmores[r].addEventListener("click", function (ev) {
        ev.preventDefault();
        this.closest("p").classList.add("active");
        this.remove();
      });
    }
    var currentPage = 1;
    document.getElementById("appendMoreReviews").addEventListener("click", (ev) => {
      ev.preventDefault();
      currentPage = currentPage + 1;
      if (currentPage == 4) {
        document.getElementById("appendMoreReviews").remove();
      }
      document.getElementById("reviewsList").dataset.page = currentPage;
    });
    document.getElementById("leaveReview").addEventListener("click", (ev) => {
      ev.preventDefault();
      document.querySelector(".reviews-modal").classList.add("visible");
    });
    document.getElementById("closeModal").addEventListener("click", (ev) => {
      ev.preventDefault();
      document.querySelector(".reviews-modal").classList.remove("visible");
    });
  },
  randomizeReviews: function () {
    var strings = ["Today", "1 Day Ago", "2 Days Ago", "3 Days Ago", "4 Days Ago", "Last Week", "Last Month"];
    var waybacks = document.querySelectorAll(".testimonials__card-author small");
    for (var i = 0; i < waybacks.length; i++) {
      waybacks[i].innerText = strings[Pawfy.randomInteger(0, 6)];
    }
  },
  upsellToggles: function () {
    var upsellToggles = document.querySelectorAll(".upsellToSub__input");
    for (var j = 0; j < upsellToggles.length; j++) {
      upsellToggles[j].addEventListener("change", function () {
        var controls = this.closest("li").querySelectorAll("label.upsellToSub");

        [].forEach.call(controls, (el) => {
          el.classList.add("active");
        });
        var theVariant = this.value.split(":")[0],
          qty = this.dataset.qty;
        var xhr = new XMLHttpRequest();
        xhr.onreadystatechange = function () {
          if (xhr.readyState == 4 && xhr.status == 200) {
            var xhrSUB = new XMLHttpRequest();
            xhrSUB.onreadystatechange = function () {
              if (xhrSUB.readyState == 4 && xhrSUB.status == 200) {
                window.location.href = "/cart";
              }
            };
            xhrSUB.open("POST", "/cart/add.js", true);
            xhrSUB.setRequestHeader("Content-Type", "application/json");
            xhrSUB.send(
              JSON.stringify({
                items: [
                  {
                    quantity: qty,
                    id: theVariant,
                    selling_plan: getSellingPlan[theVariant][0],
                  },
                ],
              })
            );
          }
        };
        xhr.open("POST", "/cart/change.js", true);
        xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
        xhr.send("line=" + this.closest("li").dataset.cartItemIndex + "&quantity=0");
      });
    }
  },
  initSubFlow: function () {
    Pawfy.setCookie("subscription_customer", JSON.stringify({ isSub: true, email: "" }), 365);
    if (document.body.classList.contains("recharge-login")) {
      var customer = JSON.parse(Pawfy.getCookie("subscription_customer"));
      var isSub = customer.isSub,
        customerEmail = customer.email;
      if (isSub && !!document.getElementById("customer_email")) {
        document.getElementById("customer_email").value = customerEmail;
        document.getElementById("login_verification").submit();
      }
    }
  },
  initBundler: function (js) {
    if (document.querySelectorAll(".addMultiple").length > 0) {
      var bundlers = document.querySelectorAll(".addMultiple");

      for (var i = 0; i < bundlers.length; i++) {
        bundlers[i].addEventListener("click", function (ev) {
          ev.preventDefault();
          var items = this.dataset.variants.split(","),
            itemsArray = [];
          for (var j = 0; j < items.length; j++) {
            itemsArray.push({
              quantity: 1,
              id: parseInt(items[j]),
              selling_plan: getSellingPlan[parseInt(items[j])][0],
              properties: {
              /*  Promo: "Multipack Bundles (" + items.length + ")",*/
              },
            });
          }
          var xhr = new XMLHttpRequest();
          xhr.onreadystatechange = function () {
            if (xhr.readyState == 4 && xhr.status == 200) {
              window.location.href = "/cart";
            }
          };
          xhr.open("POST", "/cart/add.js", true);
          xhr.setRequestHeader("Content-Type", "application/json");
          xhr.send(
            JSON.stringify({
              attributes: {
               /* Promo4: itemsArray.length + " Pack Bundle",*/
              },
              items: itemsArray,
            })
          );
        });
      }
    }
  },
  disableEmptyAddToCart: function (js) {
    var choices = document.querySelectorAll('[name="qty"]');
    for (i = 0; i < choices.length; i++) {
      choices[i].addEventListener("click", function () {
        document.querySelector(".product-atf__right-purchasetype--active .addToCart").classList.remove("disabled");
      });
    }
  },
  productQuantitySelectorsBind: function (js) {
    document.querySelectorAll("input[name='purchasetype']").forEach((elem) => {
      elem.addEventListener("click", function () {
        document.querySelector(".product-atf__right-purchasetype--active").classList.remove("product-atf__right-purchasetype--active");
        elem.closest(".product-atf__right-purchasetype").classList.add("product-atf__right-purchasetype--active");
      });
    });

    document.querySelectorAll("input[name='qty']").forEach((elem) => {
      elem.addEventListener("click", function () {
        elem.closest(".collapser").classList.toggle("collapsed");
      });
    });

    document.querySelectorAll(".upsell").forEach((elem) => {
      elem.addEventListener("click", function () {
        elem.querySelector("input").checked = !elem.querySelector("input").checked;

        document.querySelectorAll("[data-cart-price]").forEach((cartPrice) => {
          cartPrice.innerText =
            "- £" +
            parseFloat(
              Number(
                cartPrice.innerText
                  .replace("-", "")
                  .trim()
                  .replace(/[^0-9.-]+/g, "")
              ) + (elem.querySelector("input").checked ? 19.99 : -19.99)
            ).toFixed(2);
        });
      });
    });

    document.querySelectorAll('[name="qty"]').forEach((quantity) => {
      quantity.addEventListener("click", function (ev) {
        for (var lis = this.closest("div").querySelectorAll("label"), l = 0; l < lis.length; l++) lis[l].classList.remove("come-first");
        this.closest("label").classList.add("come-first");
        Pawfy.initUpsell(this.value);

        document.querySelectorAll("[data-cart-price]").forEach((cartPrice) => {
          cartPrice.innerText =
            "- £" +
            parseFloat(
              Number(
                document
                  .querySelector(".product-atf__right-purchasetype--active .come-first i")
                  .innerText.trim()
                  .replace(/[^0-9.-]+/g, "")
              ) * Number(this.value)
            ).toFixed(2);
        });
      });
    });
    var flavors = document.querySelectorAll(`[name="flavor"]`);
    for (var f = 0; f < flavors.length; f++) {
      flavors[f].addEventListener("click", function () {
        document.querySelectorAll(".product-atf__right-circlechecks.product-atf__right-circlechecks--flavor label").forEach((label) => {
          label.classList.remove("active");
        });
        var flavor = document.querySelector('[name="flavor"]:checked').value,
          variant = meta.product.variants[0].id;
        window.substituteVariant = flavor == "chicken" ? Number(variant) : Number(getFlavoredVersion[variant]);
        document.querySelector('[name="flavor"]:checked').closest("label").classList.add("active");
      });
    }
  },
  cartManipulations: function (js) {
    var cartRows = document.querySelectorAll('[action="/cart"] li.cart-items__item:not(.cart-items__item--upsell)');

    for (var j = 0; j < cartRows.length; j++) {
      var that = cartRows[j];
      var variant = that.dataset.cartItemKey.split(":")[0];
      var qty = that.dataset.cartItemQuantity;

      // if (that.querySelector(".product-details [data-cart-item-property-value]").innerText.toLowerCase().indexOf("autoship") > -1) {
      //   that.querySelector(".order-discount").classList.remove("hide");
      //   var ul = that.querySelector(".order-discount");
      //   ul.innerHTML = "";
      //   var li = document.createElement("li");
      //   li.classList.add("order-discount__item", "pawfy", "subscription");
      //   li.innerHTML =
      //     '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-saletag"><path d="M10 3a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm0-3H7a1 1 0 0 0-.71.29l-6 6a1 1 0 0 0 0 1.42l4 4a1 1 0 0 0 1.42 0c.19-.2 5.8-5.81 6-6A1 1 0 0 0 12 5V2a2 2 0 0 0-2-2z" fill="#231F20"></path></svg><span data-cart-item-discount-title="">subscription</span>';
      //   ul.appendChild(li);
      // }
      if (Object.getOwnPropertyNames(discountedVariants).includes(String(variant))) {
        that.classList.add("target-offer-killed");
        that.dataset.variant = variant;
      } else {
        that.classList.add("target-offer-killer");
        that.dataset.variant = variant;
        that.dataset.killVariant = getUpsell[variant];
        if (qty > 1) {
          that.querySelector("a.remove-line").dataset.variant = variant;
          that.querySelector("a.remove-line").dataset.killVariant = getUpsell[variant];
        } else {
          that.querySelector("a.remove-line").dataset.variant = variant;
          that.querySelector("a.remove-line").dataset.killVariant = getDiscountedVariant[variant];
        }
      }
      that.querySelector("a.remove-line").addEventListener("click", function (ev) {
        ev.preventDefault();
        var thus = this;
        var xhr = new XMLHttpRequest();
        xhr.onreadystatechange = function () {
          if (xhr.readyState == 4 && xhr.status == 200) {
            location.reload();
            Pawfy.cartManipulations();
          }
        };
        xhr.open("POST", "/cart/update.js", true);
        xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");

        if (typeof thus.dataset.killVariant !== "undefined") {
          xhr.send("updates[" + thus.dataset.variant + "]=0&updates[" + thus.dataset.killVariant + "]=0");
        } else {
          xhr.send("updates[" + thus.dataset.variant + "]=0");
        }
      });
    }
    var increments = document.querySelectorAll(".cart-items__item:not(.offer) .increment"),
      decrements = document.getElementsByClassName("decrement");
    for (var i = 0; i < increments.length; i++) {
      increments[i].addEventListener("click", function () {
        this.closest("div").querySelector(".cart__qty-input").stepUp();
      });
    }

    for (var d = 0; d < decrements.length; d++) {
      decrements[d].addEventListener("click", function () {
        this.closest("div").querySelector(".cart__qty-input").stepDown();
      });
    }

    if (document.querySelector('[name="checkout"]')) {
      var selector = document.querySelector('[data-cart-wrapper] > [name="checkout"]');
      if (selector) {
        selector.remove();
      }

      if (document.querySelector(".cart-header ~ input")) {
        document.querySelector(".cart-header ~ input").remove();
      }
    }
    var rogueRows = document.querySelectorAll("li.cart-items__item.offer"),
      regularRows = document.querySelectorAll("li.cart-items__item:not(.offer):not(.cart-items__item--upsell)");

    if (rogueRows.length > 0 && regularRows.length == 0) {
      var updateString = "updates[" + rogueRows[0].dataset.cartItemKey.split(":")[0] + "]=0";
      for (var i = 1; i < rogueRows.length; i++) {
        updateString = updateString + "&updates[" + rogueRows[i].dataset.cartItemKey.split(":")[0] + "]=0";
        rogueRows[i].remove();
      }

      var xhr = new XMLHttpRequest();
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4 && xhr.status == 200) {
          location.reload();
        }
      };
      xhr.open("POST", "/cart/update.js", true);
      xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");

      xhr.send(updateString);

      return false;
    }
  },
  cartUpsell: function (js) {
    var pricing = document.querySelector(".final-price");
    var value = Number(pricing.innerText.replace(/[^0-9\.-]+/g, ""));

    document.querySelectorAll(".upsell__check").forEach((upsell) => {
      upsell.addEventListener("click", function () {
        this.classList.toggle("active");
        pricing.innerText = "£" + (this.classList.contains("active") ? value + 19.99 : value).toFixed(2) + " USD";
      });
    });
    var xmlhttp = new XMLHttpRequest(),
      smallest = 100,
      upsellItem = {};
    xmlhttp.onreadystatechange = function () {
      if (xmlhttp.readyState == XMLHttpRequest.DONE) {
        if (xmlhttp.status == 200) {
          var itemsArray = JSON.parse(xmlhttp.responseText).items;
          for (var productItem in itemsArray) {
            var quantity = itemsArray[productItem].quantity;
            if (quantity < smallest && Object.getOwnPropertyNames(regularVariants).includes(String(itemsArray[productItem].id))) {
              smallest = quantity;
              upsellItem = itemsArray[productItem];
            }
          }

          if (!document.querySelector('[action="/cart"] li.cart-items__item')) {
            return false;
          }
          var currentName = String(discountedVariants[getDiscountedVariant[upsellItem.id]]);
          var upsells = document.querySelectorAll(".discounted-product");
          var upsellParent = false;

          for (i = 0; i < upsells.length; i++) {
            upsellParent = document.querySelector("[data-kill-variant='" + upsells[i].dataset.variant + "']");
          }

          document.querySelectorAll(".cart-items__item--upsell .cart-items__item-image").forEach((image) => {
            image.querySelector("img").src = getUpsellImage[getDiscountedVariant[upsellItem.id]];
            image.classList.add(currentName.split(" ")[0].toLowerCase());
            setTimeout(function () {
              image.closest(".cart-items__item--upsell").classList.add("show");
            }, 500);
          });

          var checkouts = document.querySelectorAll("button.cart__submit.btn.btn--small-wide");

          for (i = 0; i < checkouts.length; i++) {
            checkouts[i].addEventListener("click", function (ev) {
              ev.preventDefault();
              ev.stopPropagation();
              this.classList.add("active");
              if (document.querySelectorAll(".upsell__check.active").length > 0) {
                var xhr = new XMLHttpRequest();
                var xhrSUB = new XMLHttpRequest();
                xhr.onreadystatechange = function () {
                  if (xhr.readyState == 4 && xhr.status == 200) {
                    window.location.href = "/checkout";
                  }
                };
                xhr.open("POST", "/cart/add.js", true);
                xhr.setRequestHeader("Content-Type", "application/json");
                xhr.send(
                  JSON.stringify({
                    items: [
                      {
                        quantity: 1,
                        id: getDiscountedVariant[upsellItem.id],
                        properties: {
                        /*  Promo: "Cart Special",*/
                        },
                      },
                    ],
                  })
                );
              } else {
                window.location.href = "/checkout";
              }
            });
          }
        } else if (xmlhttp.status == 400) {
          alert("There was an error 400");
        } else {
          alert("something else other than 200 was returned");
        }
      }
    };

    xmlhttp.open("GET", "/cart.js", true);
    xmlhttp.send();
  },
  klaviyoChecker: function (js) {
    var klaviyoAppeared = false;
    var klaviyoChecker = setInterval(function () {
      if (!klaviyoAppeared) {
        klaviyoAppeared = document.querySelector(".klaviyo-pawfy form");
      } else {
        var klaviyos = document.querySelectorAll("[class*='kl-private-reset-css']");
        for (var j = 0; j < klaviyos.length; j++) {
          klaviyos[j].removeAttribute("class");
        }
        document.querySelectorAll(".klaviyo-pawfy form > div > [data-testid]:last-child").forEach((testid) => {
          testid.classList.add("input-block", "input-block--flat-on-mobile");
        });

        document.querySelectorAll(".klaviyo-pawfy").forEach((testid) => {
          testid.classList.add("active");
        });
        clearInterval(klaviyoChecker);
      }
    }, 500);
  },
  getTransactionID: function () {
    const url = new URL(document.location.href);
    const searchParams = url.searchParams;

    var transactionID = searchParams.get("transaction_id");
    if (transactionID) {
      localStorage.setItem("transactionID", transactionID);
    }
  },
  pushTransactionID: function () {
    var transactionID = localStorage.getItem("transactionID");
    if (transactionID) {
      var xhr = new XMLHttpRequest();
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4 && xhr.status == 200) {
          console.log("successfully transferred transaction ID", transactionID);
        }
      };
      xhr.open("POST", "https://pawfy.go2cloud.org/", true);
      xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
      xhr.send("aff_lsr?offer_id=1&transaction_id=" + transactionID);
    }
  },
  paintNotches: function () {
    var themeColor = "#ffffff";
    if (document.body.classList.contains("new-home")) {
      themeColor = "#d0c0ec";
    }
    if (document.body.classList.contains("template-product")) {
      themeColor = getComputedStyle(document.querySelector(".product-atf__slider")).getPropertyValue("background-color");
    }
    document.getElementById("themeColor").content = themeColor;
  },
  initFloaterATC: function () {
    document.querySelectorAll("li.splide__slide.ingredient-list__ingredient").forEach((elem) => {
      elem.addEventListener("click", function () {
        this.classList.toggle("active");
      });
    });
    var el = document.querySelector(".floater-atc"),
      atcElement = document.getElementById("addToCart"),
      atcPosition = window.scrollY + atcElement.getBoundingClientRect().top;
    el.addEventListener("click", function (ev) {
      ev.preventDefault();
      if (atcElement.getAttribute("disabled") == null) {
        atcElement.click();
      } else {
        document.querySelector(".buy-ribbon__wrapper a").click();
      }
    });
    window.addEventListener("scroll", function (e) {
      if (window.scrollY > atcPosition) {
        el.classList.add("active");
      } else {
        el.classList.remove("active");
      }
    });
  },
  relatedProducts: function () {
    var relatedProducts = {
      39474579898542: ["allergy", "skincoat", "multivitamin"], //probiotic
      39403685019822: ["shampoo", "multivitamin", "probiotic"], //skincoat
      39403667325102: ["painrelief", "calming", "skincoat"], //hipjoint
      39403668078766: ["painrelief", "shampoo", "multivitamin"], //calming
      39403688296622: ["hipjoint", "calming", "multivitamin"], //painrelief
      43119155380398: ["multivitamin", "probiotic", "allergy"], //eyesupport
      43141744951470: ["probiotic", "skincoat", "shampoo"], //multivitamin
      44053690712238: ["skincoat", "calming", "multivitamin"], //shampoo
      43863228711086: ["probiotic", "skincoat", "shampoo"], // allergy
      44403171033262: ["probiotic", "multivitamin", "allergy"],
      45054690164910: ["probiotic", "multivitamin", "allergy"], //"Dental Wash",
      45054822809774: ["probiotic", "multivitamin", "allergy"], //"Urinary & Bladder"
    };
    var relatedProducts = relatedProducts[meta.product.variants[0].id];
    if (!relatedProducts) return false;
    var selector = "";
    relatedProducts.forEach((product) => {
      selector = selector + `:not(.product-${product})`;
    });
    document.querySelectorAll("#homepage-product-slider .splide__slide" + selector).forEach((element) => {
      element.remove();
    });
  },
  calculateVH: function () {
    var vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", vh + "px");
  },
  estimatedWatch: function () {
    var fromDate = new Date(new Date().setHours(48));
    var toDate = new Date(new Date().setHours(96));

    var string = ` ${fromDate.getDate()} ${fromDate.toLocaleString("default", { month: "long" }).substr(0, 3)} - ${toDate.getDate()} ${toDate
      .toLocaleString("default", { month: "long" })
      .substr(0, 3)}`;

    var elements = document.querySelectorAll(".shipping-span");
    var productTitle = document.querySelector(".product-atf__right h1").innerText.toLowerCase();
    if (productTitle.indexOf("calmingss") == -1){
    elements.forEach((element) => {
      element.innerHTML = string;
    });
  }
  },
  populateRightPanel: function (category) {
    var categories = {
      mental: {
        title: "Stress & Anxiety",
        body: "Dogs have to navigate many social situations that could lead to stress, such as meeting people daily or being left apart from their beloved parents. Give them the peace of mind they so deserve with additional calming support so they can tackle these tougher situations.",
        image: "https://cdn.shopify.com/s/files/1/0506/0424/5166/files/shop-hq-calming.png?v=1697197459",
        url: "https://pawfy.co.uk/products/calming",
        listItems: ["Naturally relaxes & calms", "Supports separation anxiety", "Works for one-off events"],
      },
      allergy: {
        title: "Allergy & Immunity",
        body: "One of the biggest problems dogs face in the modern world is that of seasonal allergies and weakened immune systems. Supporting their immune system with the right nutrients can help protect and support symptoms such as itching, paw licking, eating grass and a whole host of other issues.",
        image: "https://cdn.shopify.com/s/files/1/0506/0424/5166/files/shop-hq-allergy.png?v=1697197459",
        url: "https://pawfy.co.uk/products/allergy-immune",
        listItems: ["Reduces Paw Biting, Licking", "Boosts Immunity Naturally", "Supports Seasonal Allergies"],
      },
      eye: {
        title: "Eyesight",
        body: "It's a known fact that dogs gradually lose their eyesight over time, some worse than others. One way to help slow this down is by ensuring your dog has the right nutrients required specifically for their eye health with a carefully curated supplement.",
        image: "https://cdn.shopify.com/s/files/1/0506/0424/5166/files/shop-hq-eye-support.png?v=1697197459",
        url: "https://pawfy.co.uk/products/eye-support",
        listItems: ["Supports Eye Health", "Reduces Tear Stains", "Supports Healthy Eyesight"],
      },
      skin: {
        title: "Skin & Coat",
        body: "Looking good and feeling good always go hand in hand. Your dog loses their shine over time and everyday living can lead to sores, allergies, balding or inflammation. Using the right oils can be key to restoring their coat. They need the support to maintain their healthy coat and give them their comfort back.",
        image: "https://cdn.shopify.com/s/files/1/0506/0424/5166/files/shop-hq-skin-coat.png?v=1697197459",
        url: "https://pawfy.co.uk/products/skin-coat",
        listItems: ["Helps renew the coat", "Prevents hair loss", "Restores shine & softness"],
      },
      anal: {
        title: "Anal Glands",
        body: "We may not want to talk about it, but it's a thing - nasty odors, leakage and constipation or loose stools can be a major mess for dog parents. Taking them to the vet isn't always financially feasible, so helping them express their anal glands with a scientifically formulated product can help.",
        image: "https://cdn.shopify.com/s/files/1/0506/0424/5166/files/analglands_x400.png?v=1667978221",
        url: "https://pawfy.co.uk/products/anal-glands",
        listItems: ["Naturally expresses glands", "Bulks up the stool", "Reduces odor & mess"],
      },
      bladder: {
        title: "Bladder",
        body: "From bladder stones to UTIs, these are the kinds of issues many parents don't prepare for till it is too late. Being proactive can help reduce headaches, heartaches and stress for you while also helping your dog avoid the pain, anxiety and discomfort that comes with UTIs.",
        image: "https://cdn.shopify.com/s/files/1/0506/0424/5166/files/shop-urinary.png?v=1716464312",
        url: "https://pawfy.co.uk/products/urinary-bladder",
        listItems: ["Defends against UTIs", "Supports bladder health", "Soothes inflammation"],
      },
      hip: {
        title: "Hip & Joint",
        body: "80% of dogs over the age of 5 start to show serious signs of joint wear & tear, or worse, severe injury. Their legs are the wheels that keep them going, playing and enjoying life. It's therefore one of the mandatory supplements many vets recommend to supplement your dog's diet.",
        image: "https://cdn.shopify.com/s/files/1/0506/0424/5166/files/shop-hq-hip-joint1.png?v=1697197458",
        url: "https://pawfy.co.uk/products/hip-and-joint",
        listItems: ["Promotes Flexibility", "Supports Stronger Joints", "Helps Pain & Discomfort"],
      },
      gut: {
        title: "Gut & Digestion",
        body: "Science has shown time and time again that more than 90% of their immune system rests in their gut. It is a crucial centre that dictates their health in many ways. Adding a strong, clinically researched probiotic to the mix can drastically improve their wellbeing.",
        image: "https://cdn.shopify.com/s/files/1/0506/0424/5166/files/shop-hq-probiotic.png?v=1697197459",
        url: "https://pawfy.co.uk/products/probiotic",
        listItems: ["Improves Gut Bacteria", "Boosts Immunity", "Reduces Paw Licking, Itching"],
      },
    };
    return categories[category];
  },
  initNoseToNail: function () {
    var elements = document.querySelectorAll("[data-product-category]");
    var circles = document.querySelectorAll("[data-cat]");
    elements.forEach((element) => {
      ["click", "mouseover"].forEach(function (evt) {
        element.addEventListener(evt, function () {
          var selectedCategory = element.dataset.productCategory;
          // document.querySelector(".line-1").style.opacity = 0;
          // document.querySelector(".line-2").style.opacity = 0;

          elements.forEach((element) => {
            element.classList.remove("hover");
          });
          circles.forEach((circle) => {
            circle.classList.remove("active");
          });
          document.querySelectorAll(`[data-cat='${selectedCategory}']`).forEach((cats) => {
            cats.classList.add("active");
          });
          this.classList.add("hover");
          var data = Pawfy.populateRightPanel(selectedCategory);
          document.getElementById("product-name").innerText = data.title;
          document.getElementById("product-name-1").innerText = data.title;
          document.getElementById("product-body").innerText = data.body;
          document.getElementById("product-image").src = data.image;
          data.listItems.forEach((elem, i) => {
            document.getElementById(`product-perk-${i}`).innerText = elem;
          });
          document.getElementById("product-url").href = data.url;
          setTimeout(function () {
            document.querySelector(".line-1").style.opacity = 1;
            setTimeout(function () {
              document.querySelector(".line-2").style.opacity = 1;
            }, 300);
          }, 300);
        });
      });
    });
  },
  initHelpfulMarkers: function () {
    var markers = document.querySelectorAll(".helpfull-marker");
    if (!!markers.length) {
      markers.forEach((marker) => {
        marker.addEventListener("click", function (ev) {
          ev.preventDefault();
          this.classList.toggle("active");
        });
      });
    }
  },
  initEndorsements: function () {
    var index = 0;
    var endorsements = [
        "I love supporting a company that has a great satisfaction guarantee on their products. Pawfy not only makes appetizing chews that are easy to administer to our patients but also offers ingredient transparency with production right here in the United States. There is a wide variety of tailored formulas to offer something for everybody.",
        "I love recommending Pawfy products to owners looking for ways to promote their pet’s overall health and vitality, as well as those seeking holistic solutions to specific concerns. Pawfy carefully selects ingredients supported by independent studies, and it’s this focus on the evidence behind the nutrients, as well as unwavering emphasis on quality, that have made me a Pawfy superfan.",
      ],
      doctors = ["Dr. Whitney Dettmer <br> DVM", "Dr. Daisy May <br> DVM"],
      images = [
        "https://cdn.shopify.com/s/files/1/0506/0424/5166/files/image_2024-12-24_141305148.png?v=1735045987",
        "https://cdn.shopify.com/s/files/1/0506/0424/5166/files/drdaisymay.png?v=1735213614",
      ];
    var body = document.querySelector(".vet-recommended__cell.vet-recommended__cell--body > p"),
      image = document.querySelector(".vet-badge__img img"),
      name = document.querySelector(".vet-badge__info > p"),
      controls = document.querySelectorAll(".vet-recommended__controls a");

    controls.forEach((control) => {
      control.addEventListener("click", function (e) {
        e.preventDefault();
        clearInterval(theInterval);
        callFunction();
        theInterval = setInterval(callFunction, 10000);
      });
    });

    function callFunction() {
      body.style.opacity = 0;
      image.style.opacity = 0;
      name.style.opacity = 0;
      setTimeout(function () {
        body.innerHTML = endorsements[index == 0 ? 1 : 0];
        image.src = images[index == 0 ? 1 : 0];
        name.innerHTML = doctors[index == 0 ? 1 : 0];
        index = index == 0 ? 1 : 0;
        setTimeout(function () {
          body.style.opacity = 1;
          image.style.opacity = 1;
          name.style.opacity = 1;
        }, 500);
      }, 500);
    }
    var theInterval = setInterval(callFunction, 10000);
  },
};
var timeout = false;
window.addEventListener("resize", function () {
  // clear the timeout
  clearTimeout(timeout);
  // start timing for event "completion"
  timeout = setTimeout(Pawfy.calculateVH, 300);
});

Pawfy.calculateVH();
window.addEventListener("orientationchange", Pawfy.calculateVH);

Pawfy.customSticky();
Pawfy.initResponsiveMenu();
setTimeout(function () {
  Pawfy.initNotification();
}, 1000);
Pawfy.getTransactionID();

if (document.body.classList.contains("template-product")) {
  Pawfy.productQuantitySelectorsBind();
  Pawfy.disableEmptyAddToCart();
  Pawfy.initFloaterATC();
}

if (document.body.classList.contains("template-index")) {
  Pawfy.initEndorsements();
  Pawfy.initNoseToNail();
}
if (document.body.classList.contains("template-product") || document.body.classList.contains("product")) {
  //Pawfy.relatedProducts();

  window.addEventListener("scroll", function () {
    var elementTarget = document.querySelector(".product-atf");
    if (window.scrollY > elementTarget.offsetTop + elementTarget.offsetHeight) {
      document.querySelector(".improvement").classList.add("active");
    } else {
      document.querySelector(".improvement").classList.remove("active");
    }
  });

  document.addEventListener("DOMContentLoaded", (event) => {
    Pawfy.estimatedWatch();

    var links = document.querySelectorAll(".pawfy-tabs__links a");
    var panels = document.querySelectorAll(".pawfy-tabs__panels-panel");

    links.forEach((a) => {
      a.addEventListener("click", function (ev) {
        ev.preventDefault();
        var selectedPanel = this.dataset.id;
        links.forEach((b) => {
          b.classList.remove("active");
        });
        panels.forEach((c) => {
          c.classList.remove("active");
        });
        this.classList.add("active");
        document.querySelector(`.pawfy-tabs__panels-panel[data-id="${selectedPanel}"]`).classList.add("active");
      });
    });
  });
}

if (document.body.classList.contains("reviews")) {
  Pawfy.initReviews();
  //Pawfy.randomizeReviews();
}
if (
  document.body.classList.contains("contact-us") ||
  document.body.classList.contains("template-customers-login") ||
  document.body.classList.contains("template-customers-register")
) {
  Pawfy.toggleTabs();
}
if (document.body.classList.contains("template-cart")) {
  Pawfy.cartManipulations();
  Pawfy.cartUpsell();
  Pawfy.upsellToggles();
  if (!document.body.classList.contains("tester")) {
    Pawfy.initCarousels();
  }
}
if (!document.body.classList.contains("template-cart")) {
  Pawfy.initFAQ();
  Pawfy.initBundler();
  if (!document.body.classList.contains("tester")) {
    Pawfy.initCarousels();
  }
  Pawfy.klaviyoChecker();
}

document.addEventListener("DOMContentLoaded", function () {
  const btn = document.getElementById("back-to-top");
  if (!!btn) {
    btn.addEventListener("click", () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  }
  window.addEventListener("scroll", function () {
    Pawfy.customSticky(); 
    if (!!btn) {
      btn.classList.toggle("visible", window.scrollY > 300);
    }
  });
}); 

if (document.body.classList.contains("template-")) {
  Pawfy.rewordReCharge();
}

document.addEventListener("DOMContentLoaded", (event) => {
  Pawfy.initHelpfulMarkers();
});
